/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type ListTotalBurnedPerDayResponse = {
  data: Array<Array<any>>;
};

/** @internal */
export const ListTotalBurnedPerDayResponse$inboundSchema: z.ZodType<
  ListTotalBurnedPerDayResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(z.array(z.any())),
});

/** @internal */
export type ListTotalBurnedPerDayResponse$Outbound = {
  data: Array<Array<any>>;
};

/** @internal */
export const ListTotalBurnedPerDayResponse$outboundSchema: z.ZodType<
  ListTotalBurnedPerDayResponse$Outbound,
  z.ZodTypeDef,
  ListTotalBurnedPerDayResponse
> = z.object({
  data: z.array(z.array(z.any())),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTotalBurnedPerDayResponse$ {
  /** @deprecated use `ListTotalBurnedPerDayResponse$inboundSchema` instead. */
  export const inboundSchema = ListTotalBurnedPerDayResponse$inboundSchema;
  /** @deprecated use `ListTotalBurnedPerDayResponse$outboundSchema` instead. */
  export const outboundSchema = ListTotalBurnedPerDayResponse$outboundSchema;
  /** @deprecated use `ListTotalBurnedPerDayResponse$Outbound` instead. */
  export type Outbound = ListTotalBurnedPerDayResponse$Outbound;
}

export function listTotalBurnedPerDayResponseToJSON(
  listTotalBurnedPerDayResponse: ListTotalBurnedPerDayResponse,
): string {
  return JSON.stringify(
    ListTotalBurnedPerDayResponse$outboundSchema.parse(
      listTotalBurnedPerDayResponse,
    ),
  );
}

export function listTotalBurnedPerDayResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListTotalBurnedPerDayResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTotalBurnedPerDayResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTotalBurnedPerDayResponse' from JSON`,
  );
}
